import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import demoVideo from '../../assets/0609(1).mp4';
import './DemoCall.css';

const DemoCall = () => {
  useEffect(() => {
    // Calendly Script laden
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Demo buchen - jobdaten.com</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="demo-call-page">
        {/* Logo Header */}
        <Link to="/" className="demo-call-logo">
          <img src="./images/logo-black.svg" alt="jobdaten.com" />
        </Link>

        <div className="demo-call-container">
          
          {/* Video Section */}
          <div className="video-section">
            <div className="video-wrapper">
              <video 
                src={demoVideo} 
                controls 
                autoPlay 
                muted
                playsInline
                preload="metadata"
              >
                Dein Browser unterstützt das Video-Tag nicht.
              </video>
            </div>
          </div>

          {/* Calendly Section */}
          <div className="calendly-section">
            <div className="calendly-inline-widget" 
                 data-url="https://calendly.com/jochen-sagert/jobdaten?primary_color=8f63ff" 
                 style={{minWidth: '320px', height: '700px'}}>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default DemoCall;
